import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

function getHeaders () {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Token ${store.getters.getToken}`
  }
}

function request (method, url, data, params) {
  return axios({ method, url: `${API_BASE_URL}${url}`, headers: getHeaders(), data, params })
}

export const handicapAPI = {
  listPlayers (params = {}) {
    return request('get', '/handicap/players/', null, params)
  },
  createPlayer (data) {
    return request('post', '/handicap/players/', data)
  },
  listIdentityOptions (params = {}) {
    return request('get', '/handicap/players/identity-options/', null, params)
  },
  getPlayerOverview (playerId) {
    return request('get', `/handicap/players/${playerId}/overview/`)
  },
  updatePlayer (playerId, data) {
    return request('patch', `/handicap/players/${playerId}/`, data)
  },
  recordExternalIndex (playerId, data) {
    return request('post', `/handicap/players/${playerId}/external-index/`, data)
  },
  listConfiguration () {
    return request('get', '/handicap/configuration/')
  },
  listRounds (params = {}) {
    return request('get', '/handicap/rounds/', null, params)
  },
  createRound (data) {
    return request('post', '/handicap/rounds/', data)
  },
  batchImport (file, commit = false) {
    const data = new FormData()
    data.append('file', file)
    data.append('commit', commit ? 'true' : 'false')
    return axios.post(`${API_BASE_URL}/handicap/rounds/batch-import/`, data, {
      headers: { 'Authorization': `Token ${store.getters.getToken}` }
    })
  },
  calculate (playerId, effectiveOn = null) {
    return request('post', `/handicap/players/${playerId}/calculate/`, effectiveOn ? { effective_on: effectiveOn } : {})
  },
  publish (calculationId) {
    return request('post', `/handicap/calculations/${calculationId}/publish/`, {})
  },
  validateRound (roundId) {
    return request('post', `/handicap/rounds/${roundId}/validate_score/`, {})
  },
  invalidateRound (roundId, reason) {
    return request('post', `/handicap/rounds/${roundId}/invalidate/`, { reason })
  },
  pairRounds (roundId, pairedRoundId) {
    return request('post', `/handicap/rounds/${roundId}/pair/`, { round_id: pairedRoundId })
  },
  adjustRound (roundId, adjustment, reason) {
    return request('post', `/handicap/rounds/${roundId}/committee-adjustment/`, { adjustment, reason })
  }
}
